import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.js';

// Delegated on document — covers every [data-fancybox] link, including markup swapped in later (Sprig).
// Links sharing a data-fancybox value are grouped into one gallery.
Fancybox.bind('[data-fancybox]', {
    Carousel: {
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ['close'],
            },
        },
    },
});
